import { useCallback } from "react"
import {
  useTheme,
  ToggleButtonGroup,
  ToggleButton,
  Typography,
  Box,
} from "@mui/material"
import { useTranslation } from "providers/i18n"

export const FloorSelectionPanel = ({
  floorOptions = [],
  currentFloor,
  currentFloorOrdinal,
  onClickFloor,
}) => {
  const { t } = useTranslation()
  const theme = useTheme()

  const { root, buttonWrapper, floorButton, floorText } =
    theme.components[`FloorSelectionPanel`]?.styleOverrides || {}

  const handleChange = useCallback(
    (e, selectedFloorId) => {
      if (selectedFloorId && onClickFloor) {
        onClickFloor(selectedFloorId)
      }
    },
    [onClickFloor]
  )

  return (
    <Box sx={root}>
      <ToggleButtonGroup
        orientation="vertical"
        color="primary"
        value={currentFloor}
        exclusive
        onChange={handleChange}
        sx={buttonWrapper}
        key={currentFloorOrdinal}
      >
        {floorOptions.map(({ id, levelName }) => (
          <ToggleButton key={id} value={id} sx={floorButton}>
            <Typography variant="body2" sx={floorText}>
              {t(levelName)}
            </Typography>
          </ToggleButton>
        ))}
      </ToggleButtonGroup>
    </Box>
  )
}
